<style>

.c{
  border-top: 1px #444 solid;
  border-bottom: 1px #444 solid;
  padding: 10px 0;
}

.cont{
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
}
.cont-q{
  grid-column: 1;
}
.cont-b{
  grid-column: 2;
}

.cancel{
  display: grid;
  grid-template-columns: auto auto auto;
  align-items: center;
}
.cancel-m{
  grid-column: 1;
}
.cancel-n{
  grid-column: 2;
}
.cancel-y{
  grid-column: 3;
  margin-left: 3px;
}

</style>

<div class="c" bind:clientWidth="{width}">
  
  {#if state == 0}
  <!-- <div class="cont" in:fly="{{x: width}}" out:fade="{{duration: 200}}" on:outroend="{() => state++}"> -->
  <div class="cont" in:fly="{{x: fWidth}}">
    <div class="cont-q">Are You Going?</div>
    <div class="cont-b"><button on:click="{incHelper}">Yes</button></div>
  </div>
  {/if}
  
  {#if state == 1}
  <div in:fly="{{x: fWidth}}">
    <button on:click="{incHelper}"><i class="icon-check"></i> I'm Going</button>
  </div>
  {/if}
  
  {#if state == 2}
  <div class="cancel" in:fly="{{x: fWidth}}">
    <div class="cancel-m">Cancel?</div>
    <div class="cancel-n"><button on:click="{decHelper}">No</button></div>
    <div class="cancel-y"><button on:click="{incHelper}">Yes</button></div>
  </div>
  {/if}
  
</div>

<script>

import { fly, fade } from 'svelte/transition';

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

let width;
let fWidth;
let state = 0;

export let going = false;

$:{
  if (going) parse();
}


function parse() {
  if (going == false) state = 0;
  if (going == true) state = 1;
}


function incHelper() {
  state++;
  fWidth = width;
  
  if (state == 1) dispatch("going");
  if (state == 3) dispatch("cancel");
  
  if (state > 2) state = 0;
}

// this is only associated with tapping no in "cancel?",
// so no need to dispatch an event
function decHelper() {
  state--;
  fWidth = -width;
}

</script>